import cl from "clsx";
import React from "react";
import { ariaLabel, getConditionalClasses } from "../utils/period.js";
const NonClickablePeriod = ({ start, end, status, cropped, direction, left, width, icon, statusLabel, restProps, periodRef, }) => {
    return (React.createElement("div", Object.assign({ ref: periodRef }, restProps, { className: cl(getConditionalClasses(cropped, direction, status), restProps === null || restProps === void 0 ? void 0 : restProps.className), style: {
            width: `${width}%`,
            [direction]: `${left}%`,
        } }),
        React.createElement("span", { className: "navds-timeline__period--inner" },
            icon,
            React.createElement("span", { className: "sr-only" }, ariaLabel(start, end, status, statusLabel)))));
};
export default NonClickablePeriod;
//# sourceMappingURL=NonClickablePeriod.js.map